import linksJSON from '../data/links.json'

const baseData = linksJSON.data

const formats = linksJSON.formats

const getData = () => {
    const data = Object.assign({}, baseData);
    for (var i = 0; i < formats.length; i++) {
        data[`convert${formats[i]}`] = {
            "en": `/convert-${formats[i]}`,
            "fr": `/conversion-${formats[i]}`,
            "es": `/convertir-${formats[i]}`
        }
    }
    (["image", "PDF", ""]).forEach(element => {
        data[`compress${element}`] = {
            "en": `/compress${element.length > 0 ? `-${element}` : ""}`,
            "fr": `/compresser${element.length > 0 ? `-${element}` : ""}`,
            "es": `/comprimir${element.length > 0 ? `-${element}` : ""}`
        }
    })
    return data;
};

export const getFormats = () => (formats)

export const getLink = (page, lang) => {
    const data = getData();
    if (!data[page] || !data[page][lang]) {
        if(!lang) return('/');
        return data.home[lang]
    }
    return data[page][lang];
};

export const getHomeLinks = () => {
    const data = [];
    for (var i = 0; i < formats.length; i++) {
        data.push(`convert${formats[i]}`)
    }
    (["image", "PDF", ""]).forEach(element => {
        data.push(`compress${element}`)
    })
    data.push("splitPdf")
    return data;
}

export const getPage = (url, lang) => {
    const data = getData();
    const actualPage = Object.keys(data).find(page => url === data[page][lang])
    return actualPage || "home";
}

export const needHeader = (url, lang) => {
    const data = getData();
    const actualPage = Object.keys(data).find(page => url === data[page][lang])
    if(!actualPage) {
        return true
    } else if (data[actualPage]["no-header"]) {
        return false;
    } else {
        return true;
    }
}